export default function isLocalhost() {
    return window.location.hostname === 'localhost';
}
